import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';
import { fetchCourses } from 'redux/actions';

const CoursesFetcher = (
    {
        children
    }
) => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.courseList.courses.fetched);
    const error = useSelector(state => state.courseList.courses.error);

    useEffect(() => {
        dispatch(fetchCourses());
    }, [dispatch])

    if (error) {
        return (
            <Message heading="Error loading courses" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader />;
    }

    return children;
};

export default CoursesFetcher;
